import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import Header from "./Header";
import Cards from "./Cards";
import Results from "./Results";
import {haveResultsSelector} from "../ducks/results";

import styles from "./root.module.scss";

class Root extends React.Component {
  static propTypes = {
    haveResults: PropTypes.bool
  };

  render() {
    const {haveResults} = this.props;
    return (
      <Grid container>
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item xs={12} className={styles.content}>
          {haveResults ? <Results /> : <Cards />}
        </Grid>
      </Grid>
    );
  }
}

export default connect((state) => ({
  haveResults: haveResultsSelector(state)
}))(Root);
